const sendInBlueEvent = (event_name = false, event_data = {}) => {
    window.sendinblue && event_name && 
    window.sendinblue.track(
        event_name, /*mandatory*/
        {}, /*user property - optional*/
        event_data /*optional*/
    )
}

export const sendInBlueCartDeleted = () => {
    sendInBlueEvent("CART_DELETED");
}

export const sendInBlueCartUpdated = (event_data) => {
    /*event_data = {
        data: {
            total: "49.98",
            currency: "USD",
            items: [
                {
                    name: "Test",
                    price: "24.99",
                    quantity: 2,
                    url: "www.example.com/black-shoes",
                    image: "",
                }
            ]
        }
    }*/
    sendInBlueEvent("CART_UPDATED", event_data);
}

/*
    ####### TEST SCRIPT TO RUN IN CONSOLE #######
    sendInBlueCartUpdated = () => {
        event_data = {
            data: {
                total: "49.98",
                currency: "USD",
                items: [
                    {
                        name: "Test",
                        price: "24.99",
                        quantity: 2,
                        url: "www.example.com/black-shoes",
                        image: "",
                    }
                ]
            }
        }
        window.sendinblue.track(
            "CART_UPDATED",
            {email: "shon.elharar@gmail.com"},
            event_data
        )
    }

*/